import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`歌に生き、恋に生き`}</h1>
    <h4>{`Vissi d'arte, vissi d'amore`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Maria Callas - Vissi d'arte (Puccini, Tosca)`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/NLR3lSrqlww" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Tosca: “Vissi d’arte”`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/bLc6nfvgN8A" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <p>
      <Ex m="生きる（遠過去）" o="vivere" mdxType="Ex">Vissi</Ex> d'<Ex m="芸術" mdxType="Ex">arte</Ex>, vissi d'<Ex m="愛、恋" mdxType="Ex">amore</Ex>,
    </p>
    <Tr mdxType="Tr">私は歌に生き、恋に生きてきました</Tr>
    <p>
non <Ex m="fare male a 〜に危害を加える（遠過去）" o="fare" mdxType="Ex">feci</Ex> <Ex m="これまで一度も〜したことがない" mdxType="Ex">mai</Ex> <Ex m="悪（feciの解説を参照）" mdxType="Ex">male</Ex> ad <Ex m="魂、人" mdxType="Ex">anima</Ex> <Ex m="生きている" o="vivo" mdxType="Ex">viva</Ex>!
    </p>
    <Tr mdxType="Tr">人に悪いことをしたことは一度もありません！</Tr>
    <p>
      <Ex m="〜で" mdxType="Ex">Con</Ex> <Ex m="手" o="mano" mdxType="Ex">man</Ex> <Ex m="密かな" o="furtivo" mdxType="Ex">furtiva</Ex> <Ex m="関係詞「〜する全ての…」（ここでは「私が知り合った全ての惨めな人々」）" mdxType="Ex">quante</Ex> <Ex m="極貧、惨めさ" o="miseria" mdxType="Ex">miserie</Ex> <Ex m="知っている、知り合う（遠過去）" o="conoscere" mdxType="Ex">conobbi</Ex>, <Ex m="助ける（遠過去）" o="aiutare" mdxType="Ex">aiutai</Ex>...
    </p>
    <Tr mdxType="Tr">私が知り合った惨めな人たちには、そっと手を差し伸べ、助けてきました</Tr>
    <p>
      <Ex m="いつも" mdxType="Ex">Sempre</Ex> con <Ex m="信仰 (= fede)" mdxType="Ex">fe'</Ex> <Ex m="誠実な" o="sincero" mdxType="Ex">sincera</Ex> la <Ex m="私の" mdxType="Ex">mia</Ex> <Ex m="祈り" mdxType="Ex">preghiera</Ex> <Ex m="a （〜に） + i" mdxType="Ex">ai</Ex> <Ex m="聖なる" o="santo" mdxType="Ex">santi</Ex> <Ex m="壁龕（へきがん）、壁祭壇" o="tabernacolo" mdxType="Ex">tabernacoli</Ex> <Ex m="昇る（遠過去）" o="salire" mdxType="Ex">salì</Ex>
    </p>
    <Tr mdxType="Tr">いつも真摯な信仰をもって、私の祈りは聖なる祭壇に昇りました</Tr>
    <p>
Sempre con fe' sincera, <Ex m="与える（遠過去）" o="dare" mdxType="Ex">diedi</Ex> <Ex m="花" o="fiore" mdxType="Ex">fiori</Ex> <Ex m="= agli (a + gli)" mdxType="Ex">agl'</Ex><Ex m="供物台、祭壇" o="altare" mdxType="Ex">altar</Ex>,
    </p>
    <Tr mdxType="Tr">いつも真摯な信仰をもって、祭壇に花をお供えしました</Tr>
    <p>
      <Ex m="in （〜の中に、で） + l'" mdxType="Ex">Nell'</Ex><Ex m="時間" mdxType="Ex">ora</Ex> <Ex m="di （〜の） + il" mdxType="Ex">del</Ex> <Ex m="苦痛" mdxType="Ex">dolore</Ex> <Ex m="なぜ" mdxType="Ex">perché</Ex>, perché <Ex m="主、神" mdxType="Ex">Signore</Ex>, perché <Ex m="私に" mdxType="Ex">me</Ex> <Ex m="そのことについて" mdxType="Ex">ne</Ex> <Ex m="報いる" o="rimunerare" mdxType="Ex">rimuneri</Ex> <Ex m="このように" mdxType="Ex">così</Ex>?
    </p>
    <Tr mdxType="Tr">それなのに、この苦しみの時に、どうして、主よ、どうして私にこのような報いをくださるのですか？</Tr>
    <p>
      <Ex m="与える（遠過去）" o="dare" mdxType="Ex">Diedi</Ex> <Ex m="宝石" o="gioiello" mdxType="Ex">gioielli</Ex> <Ex m="di （〜の） + la" mdxType="Ex">della</Ex> <Ex M="聖母マリア" mdxType="Ex">Madonna</Ex> <Ex m="a （〜に） + il" mdxType="Ex">al</Ex> <Ex m="マント" mdxType="Ex">manto</Ex>,
    </p>
    <Tr mdxType="Tr">私はマリア様のマントに宝石を捧げました</Tr>
    <p>
      <Ex m="そして（英語のand）" mdxType="Ex">e</Ex> diedi il <Ex m="歌" mdxType="Ex">canto</Ex> agli <Ex m="星" o="astro" mdxType="Ex">astri</Ex>, al <Ex m="空、天" mdxType="Ex">ciel</Ex>, che <Ex m="そのことから、それで" mdxType="Ex">ne</Ex> <Ex m="笑う、きらめく（半過去 =ridevano）" o="ridere" mdxType="Ex">ridean</Ex> <Ex m="もっと〜、より〜" mdxType="Ex">più</Ex> <Ex m="美しい" o="bello" mdxType="Ex">belli</Ex>
    </p>
    <Tr mdxType="Tr">そして天の星たちに歌を捧げました。そうすると、星たちはより一層美しく輝きました</Tr>
    <p>
Nell'ora del dolor perché, perché Signor, ah, perché me ne rimuneri così?
    </p>
    <Tr mdxType="Tr">それなのに、この苦しみの時に、どうして、主よ、どうして私にこのような報いをくださるのですか？</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6590bb1d03550a924d41f76c2189aa20/8698d/tosca-vissi-d'arte.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "141.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAACXBIWXMAABcSAAAXEgFnn9JSAAACwElEQVRIx63U2U5jMQwG4Lz/O3HHIoQElKVQlrKvXdihpYWMPo9cHSHmahrJ5ySO7fy/7aTU/xyfn591MpmEfH9/1+Lz8vJS39/f69vbW31+fq7j8bg+PT3N5pw+Pj5i/+HhoQ4GgxD7w+Gw3tzc1Lu7uzqdTmvhsLi4WLe3t2u73a7dbrceHx+HbG5uxvrs7Cz2d3Z26unpadhZb21t1fPz85CDg4MAVb6+vgKukShfX18DGTRQ0N3e3oZADhVWySx1gRBlQQkFZ0aCjkajOIw+R9o3/2z4GDPKSffi4iLgo9TpdELvT2e/1WqFXF1dhe3+/n5dX18PEas4HWRo0GvK4+PjjOr9/X2gVxy2BM1erxcFkR5IS7MFwFdR8DlmZf3p7TeHtORe1iEor62tBXynnZyc1MPDw6CE4t7eXoiqs9vY2Ag768vLy+gE6cAA6iKyPtJXKGRuGHC05miufbSIdAiCqj3BUYa0/Nb98qqCzVT8HFnhn6OIqpIQQWDuVCitr6+vY22uqaHCCNImG7qosoBKjxIlR2IuGDqc8sbQCSbXmQK6o6Ojvzls0soLrspOS/rmdByyotkJuqB526IPUVIU0J0GrXm/34/rpT30pKL5o51FsceXbfSh07UCCtoD9LwdHgO06HZ3d4O6+crKStwkOeXnlsxymJWycDoaUFknDbTcprzr0GTDp0AalPHPF8VG5otO4Hz/BCT25FGAXDuYn1hFolFARSVRVXUU/aXB4+GWeP/YoSlNCwsLoZdz9GeUs8Ip0DkdCjShUBD/rCggiRJi66CcDwJD/3w0GThRGnKdLcTWOm9T88YE5eXl5YCMssqiRLSF9tFW9Kurq3VpaSloq7JHREpU2BMn3yUrB1n2UxYiexAqaXCo4A5hw49ds+FLnfOYFWVeUppJTeXP+W97/0Q4d8rzDvgHmtVadGBh9FcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/6590bb1d03550a924d41f76c2189aa20/5a190/tosca-vissi-d'arte.png",
            "srcSet": ["/static/6590bb1d03550a924d41f76c2189aa20/772e8/tosca-vissi-d'arte.png 200w", "/static/6590bb1d03550a924d41f76c2189aa20/e17e5/tosca-vissi-d'arte.png 400w", "/static/6590bb1d03550a924d41f76c2189aa20/5a190/tosca-vissi-d'arte.png 800w", "/static/6590bb1d03550a924d41f76c2189aa20/c1b63/tosca-vissi-d'arte.png 1200w", "/static/6590bb1d03550a924d41f76c2189aa20/8698d/tosca-vissi-d'arte.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      